module.exports = __webpack_public_path__ + "img/img62.59ff9316.svg";